import type { RcFile } from '../../upload';

export type Validation = {
  isValidFile?: (file: Blob | RcFile) => boolean;
  isValidImage?: (image: { height: number; width: number }) => boolean;
  key: string;
  message: string;
};

export const fileValidationError: Validation = {
  isValidFile: (file) => file.type.startsWith('image/'),
  key: 'unexpected_file_type',
  message: '{{fileName}} is not valid image.',
};

export const unexpectedError: Validation = {
  key: 'unexpected_error',
  message: 'Sorry, something went wrong.',
};

export const failedUpload: Validation = {
  key: 'network_failed_upload',
  message: 'Failed to upload',
};

export const imageDraggerDefaultValidations: Validation[] = [fileValidationError, unexpectedError, failedUpload];
